export const NAV = {
  logo: "nav-logo",
  linkHome: "nav-link-home",
  linkEv: "nav-link-ev",
  linkPerformance: "nav-link-performance",
  linkWhy: "nav-link-why",
  linkBooking: "nav-link-booking",
  linkContact: "nav-link-contact",
  ctaBook: "nav-cta-book",
  mobileToggle: "nav-mobile-toggle",
};

export const HERO = {
  section: "hero-section",
  ctaPrimary: "hero-cta-primary",
  ctaSecondary: "hero-cta-secondary",
};

export const EV = {
  section: "ev-section",
  card: (slug) => `ev-card-${slug}`,
};

export const HV = {
  section: "hv-investment-section",
};

export const PERF = {
  section: "performance-section",
  card: (slug) => `perf-card-${slug}`,
};

export const WHY = {
  section: "why-section",
  card: (slug) => `why-card-${slug}`,
};

export const GALLERY = {
  section: "gallery-section",
  tile: (i) => `gallery-tile-${i}`,
};

export const PRICING = {
  section: "pricing-section",
};

export const TESTIMONIALS = {
  section: "testimonials-section",
};

export const BOOKING = {
  section: "booking-section",
  form: "booking-form",
  name: "booking-name",
  email: "booking-email",
  phone: "booking-phone",
  reg: "booking-registration",
  vehicle: "booking-vehicle",
  work: "booking-work-required",
  dateTrigger: "booking-date-trigger",
  notes: "booking-notes",
  submit: "booking-submit",
  successAlert: "booking-success",
  errorAlert: "booking-error",
};

export const CONTACT = {
  section: "contact-section",
  form: "contact-form",
  name: "contact-name",
  email: "contact-email",
  phone: "contact-phone",
  message: "contact-message",
  submit: "contact-submit",
  successAlert: "contact-success",
  errorAlert: "contact-error",
  phoneLink: "contact-phone-link",
  emailLink: "contact-email-link",
};

export const FOOTER = {
  section: "footer-section",
};

export const HOME = {
  emergentLink: "home-emergent-link",
};
